module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder2-open-84200dca.svg";